

export class SOPutMessage {

  constructor(
    public uid: string,
    public name: string = null,
    public description: string = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPutMessage(
      'uid' in params ? params.uid : null,
      'name' in params ? params.name : null,
      'description' in params ? params.description : null,
    );
  }
}
